import { render } from "./CollectionCarouselHelper.vue?vue&type=template&id=528841c9"
import script from "./CollectionCarouselHelper.vue?vue&type=script&lang=js"
export * from "./CollectionCarouselHelper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__